function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import debounce from 'lodash.debounce';
import SearchInput from "./SearchInput.js";
import { jsx as _jsx } from "react/jsx-runtime";
class DebouncedSearchInput extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "searchInput", void 0);
    this.searchInput = /*#__PURE__*/React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.sendUpdate = debounce(this.sendUpdate.bind(this), props.debounceMs);
    this.state = {
      value: props.value
    };
  }
  componentDidUpdate(prevProps) {
    var value = this.props.value;
    if (prevProps.value !== value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        value
      });
    }
  }
  focus() {
    var _this$searchInput$cur;
    (_this$searchInput$cur = this.searchInput.current) === null || _this$searchInput$cur === void 0 || _this$searchInput$cur.focus();
  }
  handleChange(event) {
    this.setState({
      value: event.target.value
    }, this.sendUpdate);
  }
  sendUpdate() {
    var onChange = this.props.onChange;
    var value = this.state.value;
    onChange(value);
  }
  render() {
    var _this$props = this.props,
      placeholder = _this$props.placeholder,
      className = _this$props.className,
      matchCount = _this$props.matchCount,
      id = _this$props.id,
      dataTestId = _this$props['data-testid'];
    var value = this.state.value;
    return /*#__PURE__*/_jsx(SearchInput, {
      value: value,
      placeholder: placeholder,
      onChange: this.handleChange,
      className: className,
      matchCount: matchCount,
      ref: this.searchInput,
      id: id,
      "data-testid": dataTestId
    });
  }
}
_defineProperty(DebouncedSearchInput, "defaultProps", {
  placeholder: 'Search',
  className: '',
  matchCount: null,
  debounceMs: 250,
  id: '',
  'data-testid': undefined
});
export default DebouncedSearchInput;
//# sourceMappingURL=DebouncedSearchInput.js.map